import WastInfo from "../config/wast";

const translations: { [key: string]: string } = {
  "404.title": "Oops! This page is not found...",
  "404.text": "Go back to",
  "404.home": "homepage",
  addPaymentMethod: "Add a payment method",
  "address.add": "Add address",
  "address.type.home": "Home",
  "address.type.office": "Office",
  "address.type.other": "Other",
  "address.notes.title": "Add instructions to your address",
  "address.notes.text":
    "Do we need a front door code or an intercom number? (optional)",
  "address.notes.placeholder": "Intercom / Building / Code ...",
  "addresses.back": "Back to my addresses",
  "addresses.selectAddress": "Or select an address from your saved addresses:",
  "addresses.title": "My adresses",
  awaitingPickup: "Awaiting pickup",
  "area.title": "Your laundry washed today",
  "area.description":
    "Enter your address to find out if we deliver to your zone",
  "area.button": "Confirm",
  "button.deeplink.download": "Download the app",
  "banner.title.one": "Flexible",
  "banner.title.two": "Fast",
  "banner.title.three": "Attractive pricing",
  "banner.description.one": "Available 7d/7 from 7am to 10pm",
  "banner.description.two": "Express delivery in 24 hours",
  "banner.description.three": "Free collection & delivery",
  canceled: "Order canceled",
  comingsoon: "Not available",
  "pickup.pickdate": "Pick a day",
  "pickup.picktime": "Pick a slot",
  "cart.address.fillAddress": "Fill your address",
  "cart.address.title": "Shipping address",
  "cart.change": "Change",
  "cart.discount.discountCodeApplied": "Code applied",
  "cart.discount.enterDiscountCode": "Enter your discount code",
  "cart.finaliseOrder": "Finalize the order",
  "cart.options.deliveryCost": "Shipping cost {price}€",
  "cart.options.processDelay": "Processing time {pickupLeadTime}h",
  "cart.options.timeslotDuration": "Timeslots {timeslotDuration} min",
  "cart.options.title": "Options",
  "cart.order.personalizeCart": "Personalize my cart (Optional)",
  "cart.order.personalizeOrFinishOrder":
    "You can finish your order or personalize it by checking our services",
  "cart.order.title": "Order",
  "cart.shippingTime.chooseAddressBeforeTime":
    "Choose an address before choosing hours",
  "cart.shippingTime.dropoff": "Dropoff",
  "cart.shippingTime.modal.title": "Choose a slot",
  "cart.shippingTime.pickup": "Pickup",
  "cart.shippingTime.selectDropOffRange": "Choose a dropoff slot",
  "cart.shippingTime.selectPickupRange": "Choose a pickup slot",
  "cart.shippingTime.title": "Hours",
  "cart.shippingTime.today": "Today",
  "cart.shippingTime.tomorrow": "Tomorrow",
  "cart.shippingTime.validate": "Validate",
  "cart.title": "Place an order",
  "cart.widget.legal":
    "*We remind you that the final clothes count will take place in our pressing. The final price can vary accordingly.<br />Minimum order 15€.",
  "cart.widget.order": "Order now",
  "cart.widget.price": "Total",
  "cart.widget.tax": "(Tax included)",
  "cart.ribbon.text": "Optional",
  cgu: `<?xml version="1.0" encoding="UTF-8"?>
  <!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.1 plus MathML 2.0//EN" "http://www.w3.org/Math/DTD/mathml2/xhtml-math11-f.dtd"><html xmlns="http://www.w3.org/1999/xhtml" lang="en-US"><!--This file was converted to xhtml by LibreOffice - see https://cgit.freedesktop.org/libreoffice/core/tree/filter/source/xslt for the code.--><head profile="http://dublincore.org/documents/dcmi-terms/"><meta http-equiv="Content-Type" content="application/xhtml+xml; charset=utf-8"/><title xml:lang="en-US">- no title specified</title><meta name="DCTERMS.title" content="" xml:lang="en-US"/><meta name="DCTERMS.language" content="en-US" scheme="DCTERMS.RFC4646"/><meta name="DCTERMS.source" content="http://xml.openoffice.org/odf2xhtml"/><meta name="DCTERMS.issued" content="2020-11-09T09:31:00" scheme="DCTERMS.W3CDTF"/><meta name="DCTERMS.modified" content="2020-11-09T12:21:00" scheme="DCTERMS.W3CDTF"/><meta name="xsl:vendor" content="libxslt"/><link rel="schema.DC" href="http://purl.org/dc/elements/1.1/" hreflang="en"/><link rel="schema.DCTERMS" href="http://purl.org/dc/terms/" hreflang="en"/><link rel="schema.DCTYPE" href="http://purl.org/dc/dcmitype/" hreflang="en"/><link rel="schema.DCAM" href="http://purl.org/dc/dcam/" hreflang="en"/><style>
      table { border-collapse:collapse; border-spacing:0; empty-cells:show }
      td, th { vertical-align:top; font-size:12pt;}
      h1, h2, h3, h4, h5, h6 { clear:both;}
      ol, ul { margin:0; padding:0;}
      li { list-style: none; margin:0; padding:0;}
      span.footnodeNumber { padding-right:1em; }
      span.annotation_style_by_filter { font-size:95%; font-family:Arial; background-color:#fff000;  margin:0; border:0; padding:0;  }
      span.heading_numbering { margin-right: 0.8rem; }* { margin:0;}
      .Footer { font-size:10pt; margin-bottom:0in; margin-top:0in; text-align:left ! important; font-family:Calibri; writing-mode:horizontal-tb; direction:ltr; }
      .Heading_20_1 { font-size:14pt; font-family:Arial; writing-mode:horizontal-tb; direction:ltr; margin-top:0in; margin-bottom:0in; line-height:130%; text-align:left ! important; color:#051259; font-weight:bold; }
      .P1 { font-size:10pt; margin-bottom:0in; margin-top:0in; text-align:left ! important; font-family:Calibri; writing-mode:horizontal-tb; direction:ltr; margin-left:0in; margin-right:0.25in; text-indent:0in; }
      .P3 { color:#051259; font-size:14pt; font-weight:bold; line-height:130%; margin-bottom:0in; margin-top:0in; text-align:center ! important; font-family:Arial; writing-mode:horizontal-tb; direction:ltr; }
      .P4 { font-size:10pt; margin-bottom:0in; margin-top:0in; text-align:left ! important; font-family:Calibri; writing-mode:horizontal-tb; direction:ltr; }
      .P5 { font-size:10pt; margin-bottom:0in; margin-top:0in; text-align:center ! important; font-family:Calibri; writing-mode:horizontal-tb; direction:ltr; }
      .Standard { font-size:10pt; font-family:Calibri; writing-mode:horizontal-tb; direction:ltr; margin-top:0in; margin-bottom:0in; text-align:left ! important; }
      .T2 { font-weight:bold; }
      /* ODF styles with no properties representable as CSS:
      .dp1 .page_20_number  { } */
  </style></head><body dir="ltr" style="max-width:8.2681in;margin-top:0.9839in; margin-bottom:0.4917in; margin-left:0.9839in; margin-right:0.9839in; "><p class="P3">Conditions générales d'utilisation</p><p class="P3"> </p><p class="P5">En vigueur au 01/12/2019</p><p class="P5"> </p><p class="P4"> </p><p class="P4">Les présentes conditions générales d'utilisation (dites « <span class="T2">CGU</span> ») ont pour objet l'encadrement juridique des modalités de mise à disposition du site et des services par WASH FAST  et de définir les conditions d’accès et d’utilisation des services par « <span class="T2">l'Utilisateur</span> ».</p><p class="P4">Les présentes CGU sont accessibles sur le site à la rubrique «<span class="T2">CGU</span>».</p><p class="Standard"> </p><p class="Standard">Toute inscription ou utilisation du site implique l'acceptation sans aucune réserve ni restriction des présentes CGU par l’utilisateur. Lors de l'inscription sur le site via le Formulaire d’inscription, chaque utilisateur accepte expressément les présentes CGU en cochant la case précédant le texte suivant : « Je reconnais avoir lu et compris les CGU et je les accepte ».</p><p class="Standard">En cas de non-acceptation des CGU stipulées dans le présent contrat, l'Utilisateur se doit de renoncer à l'accès des services proposés par le site.</p><p class="Standard">www.wast.fr  se réserve le droit de modifier unilatéralement et à tout moment le contenu des présentes CGU.</p><p class="Heading_20_1"> </p><p class="Heading_20_1">Article 1 : Les mentions légales</p><p class="Heading_20_1"> </p><p class="Standard">L'édition du site www.wast.fr est assurée par la Société SAS WASH FAST au capital de 2 223 207,30 € euros, immatriculée au RCS de Versailles B 821 922 507 sous le numéro 821922507, dont le siège social est situé au 64 T AV CHARLES TELLIER 78800 HOUILLES</p><p class="Standard">Numéro de téléphone +33 1 82 83 44 80</p><p class="Standard">Adresse e-mail : info@wast.fr.</p><p class="Standard">Le Directeur de la publication est : GOURDET DAVID</p><p class="Standard">Numéro de TVA intracommunautaire : FR 82 821922507</p><p class="Standard"> </p><p class="Standard">L'hébergeur du site www.wast.fr est la société _______________, dont le siège social est situé au _______________, avec le numéro de téléphone : _______________.</p><p class="Heading_20_1"> </p><p class="Heading_20_1">ARTICLE 2 : Accès au site</p><p class="Heading_20_1"> </p><p class="Standard">Le site www.wast.fr  permet à l'Utilisateur un accès gratuit aux services suivants :</p><p class="Standard">Le site internet propose les services suivants :</p><p class="Standard">Pressing, laverie, retouches</p><p class="Standard">Le site est accessible gratuitement en tout lieu à tout Utilisateur ayant un accès à Internet. Tous les frais supportés par l'Utilisateur pour accéder au service (matériel informatique, logiciels, connexion Internet, etc.) sont à sa charge.</p><p class="Standard"> </p><p class="Standard">L’Utilisateur non membre n'a pas accès aux services réservés. Pour cela, il doit s’inscrire en remplissant le formulaire. En acceptant de s’inscrire aux services réservés, l’Utilisateur membre s’engage à fournir des informations sincères et exactes concernant son état civil et ses coordonnées, notamment son adresse email.</p><p class="Standard">Pour accéder aux services, l’Utilisateur doit ensuite s'identifier à l'aide de son identifiant et de son mot de passe qui lui seront communiqués après son inscription.</p><p class="Standard">Tout Utilisateur membre régulièrement inscrit pourra également solliciter sa désinscription en se rendant à la page dédiée sur son espace personnel. Celle-ci sera effective dans un délai raisonnable.</p><p class="Standard">Tout événement dû à un cas de force majeure ayant pour conséquence un dysfonctionnement du site ou serveur et sous réserve de toute interruption ou modification en cas de maintenance, n'engage pas la responsabilité de www.wast.fr. Dans ces cas, l’Utilisateur accepte ainsi ne pas tenir rigueur à l’éditeur de toute interruption ou suspension de service, même sans préavis.</p><p class="Standard">L'Utilisateur a la possibilité de contacter le site par messagerie électronique à l’adresse email de l’éditeur communiqué à l’ARTICLE 1.</p><p class="Heading_20_1"> </p><p class="Heading_20_1">ARTICLE 3 : Collecte des données</p><p class="Heading_20_1"> </p><p class="Standard">Le site assure à l'Utilisateur une collecte et un traitement d'informations personnelles dans le respect de la vie privée conformément à la loi n°78-17 du 6 janvier 1978 relative à l'informatique, aux fichiers et aux libertés. Le site est déclaré à la CNIL sous le numéro _______________.</p><p class="Standard">En vertu de la loi Informatique et Libertés, en date du 6 janvier 1978, l'Utilisateur dispose d'un droit d'accès, de rectification, de suppression et d'opposition de ses données personnelles. L'Utilisateur exerce ce droit :</p><p class="Standard">·         par mail à l'adresse email info@wast.fr﻿</p><p class="Heading_20_1"> </p><p class="Heading_20_1">ARTICLE 4 : Propriété intellectuelle</p><p class="Heading_20_1"> </p><p class="Standard">Les marques, logos, signes ainsi que tous les contenus du site (textes, images, son…) font l'objet d'une protection par le Code de la propriété intellectuelle et plus particulièrement par le droit d'auteur.</p><p class="Standard"> </p><p class="Standard">La marque WAST est une marque déposée par WASH FAST SAS.Toute représentation et/ou reproduction et/ou exploitation partielle ou totale de cette marque, de quelque nature que ce soit, est totalement prohibée.</p><p class="Standard"> </p><p class="Standard">L'Utilisateur doit solliciter l'autorisation préalable du site pour toute reproduction, publication, copie des différents contenus. Il s'engage à une utilisation des contenus du site dans un cadre strictement privé, toute utilisation à des fins commerciales et publicitaires est strictement interdite.</p><p class="Standard">Toute représentation totale ou partielle de ce site par quelque procédé que ce soit, sans l’autorisation expresse de l’exploitant du site Internet constituerait une contrefaçon sanctionnée par l’article L 335-2 et suivants du Code de la propriété intellectuelle.</p><p class="Standard">Il est rappelé conformément à l’article L122-5 du Code de propriété intellectuelle que l’Utilisateur qui reproduit, copie ou publie le contenu protégé doit citer l’auteur et sa source.</p><p class="Standard"> </p><p class="Heading_20_1">ARTICLE 5 : Responsabilité</p><p class="Heading_20_1"> </p><p class="Standard">Les sources des informations diffusées sur le site www.wast.fr sont réputées fiables mais le site ne garantit pas qu’il soit exempt de défauts, d’erreurs ou d’omissions.</p><p class="Standard">Les informations communiquées sont présentées à titre indicatif et général sans valeur contractuelle. Malgré des mises à jour régulières, le site www.wast.fr ne peut être tenu responsable de la modification des dispositions administratives et juridiques survenant après la publication. De même, le site ne peut être tenue responsable de l’utilisation et de l’interprétation de l’information contenue dans ce site.</p><p class="Standard">L'Utilisateur s'assure de garder son mot de passe secret. Toute divulgation du mot de passe, quelle que soit sa forme, est interdite. Il assume les risques liés à l'utilisation de son identifiant et mot de passe. Le site décline toute responsabilité.</p><p class="Standard">Le site www.wast.fr ne peut être tenu pour responsable d’éventuels virus qui pourraient infecter l’ordinateur ou tout matériel informatique de l’Internaute, suite à une utilisation, à l’accès, ou au téléchargement provenant de ce site.</p><p class="Standard">La responsabilité du site ne peut être engagée en cas de force majeure ou du fait imprévisible et insurmontable d'un tiers.</p><p class="Heading_20_1"> </p><p class="Heading_20_1">ARTICLE 6 : Liens hypertextes</p><p class="Heading_20_1"> </p><p class="Standard">Des liens hypertextes peuvent être présents sur le site. L’Utilisateur est informé qu’en cliquant sur ces liens, il sortira du site www.wast.fr. Ce dernier n’a pas de contrôle sur les pages web sur lesquelles aboutissent ces liens et ne saurait, en aucun cas, être responsable de leur contenu.</p><p class="Heading_20_1"> </p><p class="Heading_20_1">ARTICLE 7 : Cookies</p><p class="Heading_20_1"> </p><p class="Standard">L’Utilisateur est informé que lors de ses visites sur le site, un cookie peut s’installer automatiquement sur son logiciel de navigation.</p><p class="Standard">Les cookies sont de petits fichiers stockés temporairement sur le disque dur de l’ordinateur de l’Utilisateur par votre navigateur et qui sont nécessaires à l’utilisation du site www.wast.fr. Les cookies ne contiennent pas d’information personnelle et ne peuvent pas être utilisés pour identifier quelqu’un. Un cookie contient un identifiant unique, généré aléatoirement et donc anonyme. Certains cookies expirent à la fin de la visite de l’Utilisateur, d’autres restent.</p><p class="Standard">L’information contenue dans les cookies est utilisée pour améliorer le site www.wast.fr.</p><p class="Standard">En naviguant sur le site, L’Utilisateur les accepte.</p><p class="Standard">L’Utilisateur doit toutefois donner son consentement quant à l’utilisation de certains cookies.</p><p class="Standard">A défaut d’acceptation, l’Utilisateur est informé que certaines fonctionnalités ou pages risquent de lui être refusées.</p><p class="Standard">L’Utilisateur pourra désactiver ces cookies par l’intermédiaire des paramètres figurant au sein de son logiciel de navigation.</p><p class="Heading_20_1"> </p><p class="Heading_20_1">ARTICLE 8 : Droit applicable et juridiction compétente</p><p class="Heading_20_1"> </p><p class="Standard">La législation française s'applique au présent contrat. En cas d'absence de résolution amiable d'un litige né entre les parties, les tribunaux français seront seuls compétents pour en connaître.</p><p class="Standard">Pour toute question relative à l’application des présentes CGU, vous pouvez joindre l’éditeur aux coordonnées inscrites à l’ARTICLE 1.</p><p class="Standard"> </p><p class="Standard">CGU réalisées sur http://legalplace.fr/</p></body></html>`,
  "cgu.checkbox":
    'By checking this box, I accept the <a href="/terms">Terms of Use</a>',
  "changeAddress.redirect": "Go back to cart",
  "changeAddress.text": "You can fill your address here.",
  "changeAddress.title": "Edit the address",
  cleaning: "Cleaning",
  "company.contact.button": "Contact us now",
  "company.contact.contactInformation": "Contact information:",
  "company.contact.contactInformation.email": "B2B@wast.fr",
  "company.contact.contactInformation.tel": WastInfo.phone.formatted,
  "company.contact.form.email.label": "E-mail",
  "company.contact.form.email.placeholder": "address@mail.com",
  "company.contact.form.message.label": "Message",
  "company.contact.form.message.placeholder": "Your message here...",
  "company.contact.form.name.label": "Name",
  "company.contact.form.name.placeholder": "Wast",
  "company.contact.form.number.label": "Phone number",
  "company.contact.form.number.placeholder": "+33 X XX XX XX XX",
  "company.contact.form.submit": "Inquire now",
  "company.contact.text":
    "At Wast Corporate, we know that every company is unique. That's why we are proud to provide a tailored service tailored to the individual needs of your employees.",
  "company.contact.title": "Contact us",
  "company.description.convenient": "Convenient",
  "company.description.convenient.text":
    "We pick up your laundry at times that suit your business",
  "company.description.efficient": "Efficient",
  "company.description.efficient.text": "Clothes are delivered within 72 hours",
  "company.description.pro": "Professionnal",
  "company.description.pro.text":
    "The linen is cleaned with eco-friendly quality products",
  "company.header.button": "Contact us now",
  "company.header.meta.title": "Cleaning & laundry service for your company",
  "company.header.title": "Laundry cleaning service for your company",
  "company.services.text": "Collection and delivery to your office",
  "company.steps.title": "How does our Pressing service for businesses work?",
  "confirmAddressModal.text1":
    "Unfortunately, we are not yet available at the provided address. We are growing rapidly and hope to arrive in your neighbordhood very soon!",
  "confirmAddressModal.text2":
    "Meanwhile, you may try another area such as your place of work for example.",
  "confirmAddressModal.title": "Just a little more patience...",
  delivered: "Delivered",
  deliveryAddress: "Delivery address",
  discount: "Discount",
  addressnotetitle: "Address details (optional)",
  noteexemple: "e.g., '3rd floor, Apt. 12",
  noInformations: "No informations",
  doyouhaverequest: "Do you have any request?",
  "error.cgu.mustBeChecked": "You must agree to the Terms of Use",
  "error.paymentMethod.mustBeSelected":
    "You must add or choose a payment method",
  "error.order.not.found": "Order not found",
  "error.order.loading": "Error while loading order",
  "error.server": "Server error. Please try again",
  "error.unknown": "Unknown error",
  fees: "Fees",
  "footer.blog": "Blog",
  "footer.copyright": "Copyright © {year} Wast. All rights reserved",
  "footer.dl-app": "Download App",
  "footer.faq": "FAQ",
  "footer.help": "Help",
  "footer.info": "Informations",
  "footer.mail": `${WastInfo.mail}`,
  "footer.our-services": "Our services",
  "footer.pressing.north": "North Dry Cleaners",
  "footer.pressing.south": "South Dry Cleaners",
  "footer.wastparis": "Wast Paris",
  "footer.pressings": "Our dry cleaners",
  "footer.pricing": "Pricing",
  "footer.socials": "Social networks",
  "footer.street.1": "162 bis rue Ordener",
  "footer.city.1": "75 018 Paris",
  "footer.street.2": "97 avenue Raymond poincaré",
  "footer.city.2": "75 016 Paris",
  "footer.street.3": "15 rue Andre Lefebvre",
  "footer.city.3": "75 015 Paris",
  "footer.street.4": "27 Rue de Saint-Pétersbourg",
  "footer.city.4": "75 008 Paris",
  "footer.tel": "+33 1 82 83 44 80",
  "footer.terms": "Terms",
  "footer.title": "Contact us",
  "footer.address": "Our shops",
  free: "free",
  "general.address": "Address",
  "general.email": "Email",
  "general.deliveryType": "Delivery option",
  "general.dropoff": "Dropoff",
  "general.phone": "Phone number",
  "general.pickup": "Pickup",
  "general.wast.name": "Wast",
  given: "given",
  "home.required.field": "The address needs to be validated",
  "home.order": "Order",
  "home.discount.code": "Discount Code: PR10",
  "home.discount.condition": "*For your first order",
  "home.discount.title": "10€ Discount*",
  "home.google.autocomplete.placeholder": "I want to be delivered to my house",
  "home.map.title": "Our shipping zones in Paris",
  "home.modal.button": "Confirm address",
  "home.modal.button.loading": "Loading...",
  "home.modal.title": "Please confirm your address",
  "home.overlay.continue": "Continue on the website",
  "home.overlay.dl": "Download our app",
  "home.overlay.title":
    "Make your life easier<br />with Wast dry cleaning to your door",
  "home.press.title": "They talk about us",
  "home.service.eco": "Eco-friendly service",
  "home.service.quality": "High quality certified",
  "home.services.button": "Discover the rates",
  "home.services.laundry_bag.carpet": "Carpets and curtains",
  "home.services.laundry_bag.text_3": "Item recovered and delivered",
  "home.services.laundry_bag.eco": "Eco-friendly",
  "home.services.laundry_bag.text_1": "30° wash",
  "home.services.laundry_bag.text_2": "Machine dried, not ironed",
  "home.services.laundry_bag.title": "Laundry bag per kilogram",
  "home.services.pressing.text": "Item cleaned and ironed",
  "home.services.pressing.title": "Pressing",
  "home.services.text": "Enjoy a delivery in 24 hours at unbeatable prices",
  "home.services.title": "Our services",
  "home.signin": "Sign In",
  "home.testimonies.1.author": "Juliette A.",
  "home.testimonies.1.text":
    "I discoverd Wast through Noholita's blog and I am really happy about it! Since I live in a really tiny appartment, washing, drying and ironing you laundry is a real pain. Wast comes at the right time to help me with it and the pricing is really fair. Oh and I have to mention the great customer service, I'm satisfied and I recommend this app.",
  "home.testimonies.2.author": "Théophile Grivaux",
  "home.testimonies.2.text":
    "Very satisfied with the service! Fast! Efficient! The website is intuitive! Moreover the couriers are really cool! I recommend this service to everyone!",
  "home.testimonies.3.author": "Isabelle Alexer-Toussi",
  "home.testimonies.3.text":
    "I knew the pressing and I liked it and then I found this awesome app!! Great service for the price and very professional. To try it is to adopt it!",
  "home.testimonies.4.author": "Clément Colnot",
  "home.testimonies.4.text":
    "Really convenient&nbsp;! Thank you, keep it like that.",
  "home.testimonies.5.author": "Walid EL Mokh",
  "home.testimonies.5.text":
    "La prise en charge et la restitution du linge est faite de façon très efficace, par des équipes super sympas et sont très flexible au niveau des horaires. Concept très utile.",
  "home.testimonies.title": "They tell their story",
  "home.title": "Your Wast laundry delivered to your home in Paris",
  "home.works.desktop.1.description": "Choose the date and time that fits you",
  "home.works.desktop.1.title": "Order using the App or on Wast.fr",
  "home.works.desktop.2.description": "We collect your clothes at home",
  "home.works.desktop.2.title": "Meet you Wast driver",
  "home.works.desktop.3.description":
    "Your linen is delivered at your home in 24h* (*Express Service)",
  "home.works.desktop.3.title": "Your cleaned clothes are delivered",
  "home.works.entrust": "I entrust my clothes",
  "home.works.entrust.text":
    "Your clothes are washed in our laundries with eco-friendly products",
  "home.works.order": "I choose my order",
  "home.works.order.text": "You choose the time slot that suits you",
  "home.works.plan": "I plan my appointment",
  "home.works.plan.text":
    "One of our drivers comes to your home and picks up your clothes.",
  "home.works.receive": "I receive my order",
  "home.works.receive.text":
    "We bring back your clothes only 24 hours after pick up!",
  "home.works.text": "Get your laundry in just 3 steps",
  "home.works.title": "How it works ?",
  inProgress: "Order in progress",
  pickupScheduled: "Pickup scheduled",
  noshowPickup: "Customer unavailable at pickup",
  failedPickup: "Pickup failed",
  awaitingDeposit: "Awaiting deposit to our workshop",
  reachWorkshop: "Reach workshop",
  itemization: "Order itemization",
  recleaning: "Recleaning",
  awaitingDropoff: "Awaiting dropoff",
  noshowDropoff: "Customer unavailable at dropoff",
  failedDropoff: "Dropoff failed",
  loading: "Loading...",
  "menu.cart": "Cart",
  "menu.delivery": "Pricing",
  "menu.signup": "Sign up",
  "menu.factory": "Corporate",
  "menu.help": "Help",
  "menu.home": "Home",
  "menu.profil": "Profile",
  "menu.services": "Services",
  minimumOrderPrice: "Minimum order 15.00€ ",
  newOrder: "New order",
  "notation.comment": "Tell us why you give us this rating",
  "notation.title": "Delivery of your last order completed!",
  "notation.text": "You just have to wear your clothes clean and ironed",
  "notation.success": "Your rating has been taken into account",
  "notation.validate": "Send your rate",
  notValid: "Cart not valid",
  noCard: "Choose a payment method",
  "newsletter.title": "Wast newsletter",
  "newsletter.input":
    "Subscribe to our newsletter and receive all our best offers",
  "newsletter.placeholder": "Enter your email address",
  "newsletter.button": "Subscribe",
  optionnalInfo: "Optionnal information",
  order: "Order",
  "order.seeMoreDetails": "See more details",
  orderAgain: "Order again",
  orderCancel: "Cancel",
  orderReschedule: "Reschedule",
  "orderConfirmation.download.description":
    "To check the status of your order at any time, we recommend you to download and use our free mobile application",
  "orderConfirmation.download.title": "It's easier with our app!",
  "orderConfirmation.help.opening":
    "Mon-Fri: 7h-10h & 18h-22h<br />Sat: 9h-14h<br />Sun: 18h-22h",
  "orderConfirmation.help.title": "Any question ?",
  "orderConfirmation.next.title": "Next steps",
  "orderConfirmation.next.step1.description":
    "You clothes are collected and sorted.",
  "orderConfirmation.next.step1.title": "Pickup",
  "orderConfirmation.next.step2.description":
    "Your clothes are cleaned with  the utmost care by our experts.",
  "orderConfirmation.next.step2.title": "Cleaning",
  "orderConfirmation.next.step3.description":
    "we deliver your laundry at home or at work.",
  "orderConfirmation.next.step3.title": "Dropoff",
  "orderConfirmation.orders.button": "Your orders",
  "orderConfirmation.orders.title": "Check your orders' statuses",
  "orderConfirmation.title":
    "Your order n°{orderNb} have successfully been placed!",
  "orderConfirmation.tracking.canceled":
    "Your order n°{orderNb} have been canceled!",
  "orderConfirmation.tracking.inProgress":
    "Your order n°{orderNb} is being processed!",
  "orderConfirmation.tracking.over": "Your order n°{orderNb} is complete!",
  "paymentMethods.title": "Payment methods",
  orderNumber: "Order number",
  payment: "Payment",
  "payment.card.save": "Save card",
  "payment.delete-method": "Deleting...",
  "payment.delete-method.title": "Delete",
  "payment.set.default.method": "Default mode update...",
  "payment.set.default.method.title": "Choose this as default mode",
  "payment.redirectCart": "Back to cart",
  "pricing.noresult": "No result matching your search",
  "pricing.search.placeholder": "Search an item...",
  "pricing.title": "Pricing pressing & linen",
  "pricing.title.luxury": "Dry cleaning - Luxury",
  "pricing.title.highquality": "Dry cleaning - High quality",
  "pricing.subtitle.luxury":
    "Specialized stain removal before the dry-cleaning, then a 100% traditional ironing and finishing.",
  "pricing.subtitle.highquality":
    "Stain removal and an ironing by hand or robot, in addition to dry-cleaning.",
  "profile.home.addresses.text": "To manage your addresses, ",
  "profile.add-payment": "Add a payment method",
  "profile.add-payment.success": "Payment method successfully added",
  "profile.add-payment.error": "Error while adding the payment method",
  "profile.add-payment.text":
    "Please fill in the information of your credit card",
  "profile.here": "click here",
  "profile.home.orders": "My orders",
  "profile.home.orders.text": "To see your orders, ",
  "profile.home.cart.text": "To order, ",
  "profile.home.payment.text": "To manage your payment methods, ",
  "profile.home.delAccount.text": "To delete your account, ",
  "profile.home.title": "My profile",
  "profile.logout": "Logout",
  "profile.orders.noOrder": "You don't have any orders yet!",
  "profile.orders.title": "My orders",
  "profile.orders.pickupInfo": "Expected recovery on",
  "profile.orders.dropoffInfo": "Return scheduled for",
  "profile.payment": "My payment methods",
  "profile.delAccount": "Delete your account",
  "profile.delAccount.confirmation": "Yes",
  "profile.delAccount.not": "No",
  "profile.delAccount.confirmation.text":
    "Are you sure you want to delete your account ?",
  "placeholder.number.deeplink": "Phone number",
  "progress-bar.cart.text": "Cart",
  "progress-bar.order.text": "Summary",
  "progress-bar.confirmation.text": "Confirmed",
  "progress-bar.inscription.text": "Inscription",
  "progress-bar.connexion.text": "Connection",
  ready: "Order ready",
  "seo.city.discount": "10€ discount on your 1st order with the code LINGE10",
  "seo.city.shipping": "Free delivery 7 days a week",
  "seo.city.shirt": "Shirts from 3€",
  "seo.contact.linkButton": "Get the download link",
  "seo.contact.telButton": "Enter your phone number",
  "seo.contact.text": "Create your account now, it's simple and free",
  "seo.contact.title": "Give us your laundry today",
  "seo.description.flexible": "Flexible",
  "seo.description.flexible.text": "Available 7 days a week from 7am to 10pm",
  "seo.description.prices": "Attractive prices",
  "seo.description.prices.text": "Free collection & delivery",
  "seo.description.pro": "Professionnal",
  "seo.description.pro.text": "Express delivery 24h",
  "seo.otherLinks.cities": "Other cities",
  "seo.otherLinks.districts": "Districts",
  "seo.otherLinks.districtsInCity": "In the same city",
  "seo.otherLinks.districtsInParis": "In the same borough",
  "seo.otherLinks.serviceCities": "Service available",
  "seo.prices.button": "Check our prices here",
  "seo.prices.cleaned": "Cleaned & folded linen",
  "seo.prices.cleaned.text":
    "Billed per kilo, our linen service is perfect for your daily laundry. Your items will be washed together at 30°C, tumble dried and folded. Each bag of linen is charged per kilo with a minimum of 3 kg per order.",
  "seo.prices.pressing": "Pressing & Ironing",
  "seo.prices.pressing.text":
    "Billed by the piece, our dry cleaning and ironing is done by article. Each item is dry cleaned, ironed and hanged individually.",
  "seo.prices.simplePrice.price": "4.99€",
  "seo.prices.simplePrice.text": "1 x Linen per kilo (min 3 kg)",
  "seo.prices.text":
    "We offer two types of bags, one for each of our cleaning options. They will be offered at the end of your order",
  "seo.prices.title": "Our prices dry & linen per kilo",
  "seo.prices.tripePrice.shirt.price": "from 7.00€",
  "seo.prices.tripePrice.shirt.text": "Shirts",
  "seo.prices.tripePrice.shirtHanger.price": "from 3.00€",
  "seo.prices.tripePrice.shirtHanger.text": "Shirts on hanger",
  "seo.prices.tripePrice.suit.price": "from 14.00€",
  "seo.prices.tripePrice.suit.text": "Suits",
  shipping: "Shipping",
  shippingCost: "Shipping cost",
  "signin.code.placeholder": "The received code",
  "signin.create-account.switch": "I don't have an account",
  "signin.email": "Identification by password",
  "signin.email.button": "Identification",
  "signin.email.password.placeholder": "Password",
  "signin.email.placeholder": "Your email or phone number",
  "signin.login.switch": "I have an account - Signin",
  "signin.or": "OR",
  "signin.tel": "Identification by PIN code",
  "signin.tel.button": "Get your verification code",
  "signin.tel.code.button": "Confirm code",
  "signin.tel.code.placeholder": "Your received code",
  "signin.tel.example": "20 7946 0700",
  "signin.tel.placeholder": "Your mobile phone",
  "signin.use-zipjet-id": "To signin, use your Zipjet ids",
  "signup.email.placeholder": "Email",
  "signup.firstname.placeholder": "Firstname",
  "signup.lastname.placeholder": "Lastname",
  "signup.tel.placeholder": "Phone number",
  "signup.newsletter":
    "By checking this box, I agree to subscribe to Wast's newsletter",
  "signup.tel": "Inscription",
  "sms.deeplink.success": "Sent",
  total: "Total",
  welcomezipjettitle: `Welcome`,
  welcomezipjetmessage: `<p>Good news, Zipjet joins the Wast family!</p>
  <p>We are very pleased to announce the merger with the company Wast, the home cleaning platform.</p> <p>By taking advantage of the best of both services, we are convinced that we will build the most reliable, qualitative and affordable solution ever imagined. For all these reasons, we decided to join forces.</p>
  <p><strong>15€ offered</strong> on your next order with the code <strong>WASTJET</strong>, to offer you a smooth transition.</p>`,
  "covid19.title": `COVID-19 : Information`,
  "covid19.message": `Our services are temporarily unavailable. Please contact us for more information at <a href="info@wast.fr">info@wast.fr</a>`,
};

export default translations;
